<template>
  <span v-if="params && params.node && params.node.data && params.node.data.id">
    <b-button size="sm" variant="outline-secondary" @click="btnClickedHandler()">View</b-button>
  </span>
</template>

<script>
import { defineComponent } from 'vue'

// Bank-rec "View" cell renderer. Converted from Vue.extend({ template: '…' }): a runtime string template
// can't compile in the Vue 3 runtime-only / @vue/compat build (no runtime template compiler), so the cell
// rendered empty. An SFC <template> is compiled at build time. defineComponent avoids the GLOBAL_EXTEND path.
export default defineComponent({
  methods: {
    btnClickedHandler () {
      if (!this.params.data || !this.params.data.meta_name) {
        alert('Please click "View" on an individual line item, not on a grouping.')
        return
      }
      this.params.showLedgerItem(null, this.params.data)
    }
  }
})
</script>
